import React, { useState } from 'react';
import { X, Plus, Minus, ShoppingCart } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

const Cart = () => {
  const { 
    cart, 
    removeFromCart, 
    updateQuantity, 
    totalItems, 
    isCartOpen, 
    setIsCartOpen,
    total 
  } = useCart();

  return (
    <>
      {!isCartOpen ? (
        <button
          onClick={() => setIsCartOpen(true)}
          className="cart-icon fixed md:top-6 md:right-4 top-7 right-16 z-[70] bg-black text-white p-2 rounded-full hover:bg-gray-900 transition-colors"
        >
          <ShoppingCart className="w-5 h-5 md:w-6 md:h-6" />
          {totalItems > 0 && (
            <span className="absolute -top-2 -right-2 bg-custom-red text-white text-xs w-5 h-5 md:w-6 md:h-6 rounded-full flex items-center justify-center">
              {totalItems}
            </span>
          )}
        </button>
      ) : (
        <div className="fixed inset-0 z-[70] bg-black/50">
          <div className="absolute right-0 top-0 h-full w-full max-w-md bg-white shadow-xl">
            <div className="p-4 flex items-center justify-between border-b">
              <h2 className="text-lg font-bold">Panier ({totalItems})</h2>
              <button
                onClick={() => setIsCartOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="p-4 flex-1 overflow-y-auto max-h-[calc(100vh-16rem)]">
              {cart.length === 0 ? (
                <p className="text-center text-gray-500 mt-4">Votre panier est vide</p>
              ) : (
                <div className="space-y-4">
                  {cart.map((item) => (
                    <div key={item.id} className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-20 h-20 object-cover rounded"
                      />
                      <div className="flex-1">
                        <h3 className="font-medium">{item.title}</h3>
                        <p className="text-custom-red font-bold">{item.price}</p>
                        <div className="flex items-center space-x-2 mt-2">
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity - 1)}
                            className="p-1 hover:bg-gray-200 rounded transition-colors"
                          >
                            <Minus className="w-4 h-4" />
                          </button>
                          <span className="w-8 text-center">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            className="p-1 hover:bg-gray-200 rounded transition-colors"
                          >
                            <Plus className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => removeFromCart(item.id)}
                            className="ml-auto text-red-500 hover:text-red-600"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {cart.length > 0 && (
              <div className="p-4 border-t bg-white">
                <div className="flex justify-between items-center mb-4">
                  <span className="text-lg font-bold">Total:</span>
                  <span className="text-lg font-bold text-custom-red">{total.toFixed(2)} $</span>
                </div>
                <button
                  className="w-full bg-custom-red text-white py-3 rounded-md font-bold hover:bg-opacity-90 transition-colors"
                >
                  PASSER LA COMMANDE
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Cart; 